import React, { useState, useEffect } from 'react';
import Badges from './Badges';

const API_URL = 'https://nethajiprime-backend.onrender.com';
const C = { bg:'#040000',bg2:'#0e0101',bg3:'#180303',gold:'#f5c842',gold2:'#d4a843',gold3:'#b8922e',red:'#cc0000',red2:'#880000',cream:'#f0e6cc',cream2:'#c8b89a',muted:'#8a7060',border:'rgba(212,168,67,0.15)',green:'#00d480' };

const Btn = ({onClick,children,style={}}) => (
  <button onClick={onClick} style={{background:`linear-gradient(135deg,#cc0000,#880000)`,border:'none',color:'#fff',padding:'10px 24px',borderRadius:'8px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'13px',fontWeight:'800',letterSpacing:'1.5px',textTransform:'uppercase',boxShadow:'0 4px 20px rgba(180,0,0,0.4)',transition:'all 0.2s',...style}} onMouseEnter={e=>e.currentTarget.style.transform='translateY(-2px)'} onMouseLeave={e=>e.currentTarget.style.transform='none'}>{children}</button>
);

function UserProfile({ user, onBack, onVideoSelect, onUpgrade, subscription }) {
  const [likedVideos,setLikedVideos]=useState([]);
  const [subscriptions,setSubscriptions]=useState([]);
  const [allVideos,setAllVideos]=useState([]);
  const [activeTab,setActiveTab]=useState('overview');
  const [loading,setLoading]=useState(true);
  const [stats,setStats]=useState({totalLikes:0,totalSubscriptions:0,totalHypes:0});
  const [referralCode,setReferralCode]=useState('');
  const [referralCount,setReferralCount]=useState(0);
  const [copied,setCopied]=useState(false);
  const [watchStats,setWatchStats]=useState({totalVideos:0,totalMinutes:0,topSpeaker:null});
  const token = localStorage.getItem('token');

  useEffect(()=>{
    fetchProfileData(); fetchReferralCode();
    try {
      const cw = JSON.parse(localStorage.getItem('nethaji_continue_watching')||'{}');
      const entries = Object.values(cw);
      const totalSecs = entries.reduce((s,e)=>s+(e.currentTime||0),0);
      const sm={};
      entries.forEach(e=>{if(e.speaker_name)sm[e.speaker_name]=(sm[e.speaker_name]||0)+1;});
      const top=Object.entries(sm).sort((a,b)=>b[1]-a[1])[0]?.[0]||null;
      setWatchStats({totalVideos:entries.length,totalMinutes:Math.floor(totalSecs/60),topSpeaker:top});
    }catch(e){}
  },[]);

  const fetchReferralCode = async () => {
    try {
      const res=await fetch(`${API_URL}/referral/my-code`,{headers:{'Authorization':`Bearer ${token}`}});
      if(!res.ok) return;
      const d=await res.json();
      setReferralCode(d.referral_code||'');
      setReferralCount(d.referral_count||0);
    }catch(e){}
  };

  const fetchProfileData = async () => {
    try {
      const [vRes,sRes]=await Promise.all([fetch(`${API_URL}/speeches`),fetch(`${API_URL}/subscriptions`,{headers:{'Authorization':`Bearer ${token}`}})]);
      const videos=(await vRes.json()).speeches||[];
      const subs=(await sRes.json()).subscriptions||[];
      setAllVideos(videos); setSubscriptions(subs);
      const liked=await Promise.all(videos.map(v=>fetch(`${API_URL}/videos/${v.id}/like-status`,{headers:{'Authorization':`Bearer ${token}`}}).then(r=>r.json()).then(d=>({...v,liked:d.liked}))));
      const hyped=await Promise.all(videos.map(v=>fetch(`${API_URL}/videos/${v.id}/hype-status`,{headers:{'Authorization':`Bearer ${token}`}}).then(r=>r.json()).then(d=>({...v,hyped:d.hyped}))));
      setLikedVideos(liked.filter(v=>v.liked));
      setStats({totalLikes:liked.filter(v=>v.liked).length,totalSubscriptions:subs.length,totalHypes:hyped.filter(v=>v.hyped).length});
      setLoading(false);
    }catch(e){setLoading(false);}
  };

  const handleCopyLink=()=>{navigator.clipboard.writeText(`https://nethajiprime.com?ref=${referralCode}`);setCopied(true);setTimeout(()=>setCopied(false),2000);};
  const handleWhatsApp=()=>{const l=`https://nethajiprime.com?ref=${referralCode}`;window.open(`https://wa.me/?text=${encodeURIComponent(`நண்பர்களே! 🎬 நேதாஜி Prime-ல் Tamil Political speeches பாருங்கள்!\n\nஎன் invite link மூலம் sign up பண்ணா *10 நாள் free trial* கிடைக்கும்!\n\n👉 ${l}`)}`, '_blank');};
  const getMemberSince=()=>new Date(user.created_at||Date.now()).toLocaleDateString('en-IN',{month:'long',year:'numeric'});
  const getPlan=()=>{
    if(!subscription) return {label:'Free',color:C.muted};
    if(subscription.plan==='free_trial') return {label:`Trial: ${subscription.trial_days_left}d left`,color:C.green};
    if(subscription.has_access) return {label:'✅ Premium',color:C.gold};
    return {label:'🔒 Expired',color:'#ff6060'};
  };
  const plan=getPlan();

  const tabs=[
    {id:'overview',label:'👤 Overview'},
    {id:'invite',label:'📱 Invite'},
    {id:'liked',label:`❤️ Liked (${stats.totalLikes})`},
    {id:'subscriptions',label:`🔔 Following (${stats.totalSubscriptions})`},
    {id:'badges',label:'🏅 Badges'},
  ];

  const VideoGrid=({videos})=>(
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:'16px'}}>
      {videos.map(v=>(
        <div key={v.id} onClick={()=>onVideoSelect&&onVideoSelect(v)} style={{background:`linear-gradient(135deg,#1a0303,#0e0101)`,borderRadius:'10px',overflow:'hidden',cursor:'pointer',border:`1px solid ${C.border}`,transition:'all 0.25s'}}
          onMouseEnter={e=>{e.currentTarget.style.borderColor=C.gold2;e.currentTarget.style.transform='translateY(-4px)';}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.transform='none';}}>
          {v.thumbnail_url?<img src={v.thumbnail_url} alt={v.title} style={{width:'100%',height:'120px',objectFit:'cover'}}/>:<div style={{width:'100%',height:'120px',background:'rgba(212,168,67,0.06)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'2em'}}>🎬</div>}
          <div style={{padding:'12px'}}>
            <div style={{color:C.cream,fontWeight:'600',fontSize:'13px',marginBottom:'4px'}}>{v.title}</div>
            <div style={{color:C.muted,fontSize:'11px'}}>🎤 {v.speaker_name}</div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div style={{background:C.bg,minHeight:'100vh',color:C.cream,fontFamily:"'Barlow',sans-serif"}}>
      {/* Header */}
      <header style={{position:'sticky',top:0,zIndex:100,background:'rgba(4,0,0,0.97)',backdropFilter:'blur(20px)',borderBottom:`1px solid ${C.border}`,padding:'0 4%',height:'66px',display:'flex',alignItems:'center',gap:'16px'}}>
        <button onClick={onBack} style={{background:'none',border:`1px solid ${C.border}`,color:C.gold2,padding:'7px 18px',borderRadius:'20px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'13px',fontWeight:'700',letterSpacing:'1px'}}>← Back</button>
        <span style={{fontFamily:"'Cinzel',serif",fontSize:'1.2em',fontWeight:'900',color:C.gold,letterSpacing:'3px',textShadow:`0 0 20px rgba(245,200,66,0.4)`}}>MY PROFILE</span>
      </header>

      {/* Profile Hero */}
      <div style={{position:'relative',padding:'50px 4%',background:`linear-gradient(135deg, #0e0101, #1a0303)`,borderBottom:`1px solid ${C.border}`,overflow:'hidden'}}>
        <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse 70% 80% at 20% 50%, rgba(180,0,0,0.12), transparent)',pointerEvents:'none'}} />
        <div style={{maxWidth:'900px',margin:'0 auto',display:'flex',alignItems:'center',gap:'28px',flexWrap:'wrap',position:'relative'}}>
          {/* Avatar */}
          <div style={{width:'90px',height:'90px',borderRadius:'50%',background:`linear-gradient(135deg, ${C.red2}, #4a0000)`,border:`2px solid ${C.gold2}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'2.2em',fontWeight:'900',color:C.gold,flexShrink:0,boxShadow:`0 0 30px rgba(212,168,67,0.2)`}}>
            {user.full_name?.charAt(0).toUpperCase()}
          </div>
          <div style={{flex:1}}>
            <h2 style={{fontFamily:"'Cinzel',serif",fontSize:'clamp(1.4em,3vw,2em)',fontWeight:'900',color:C.gold,marginBottom:'6px',letterSpacing:'2px'}}>{user.full_name}</h2>
            <p style={{color:C.muted,fontSize:'13px',marginBottom:'12px'}}>{user.email}</p>
            <div style={{display:'flex',gap:'10px',flexWrap:'wrap',alignItems:'center'}}>
              <span style={{background:`${plan.color}22`,color:plan.color,border:`1px solid ${plan.color}44`,padding:'4px 14px',borderRadius:'20px',fontSize:'12px',fontWeight:'700',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>{plan.label}</span>
              <span style={{color:C.muted,fontSize:'12px',fontFamily:"'Barlow Condensed',sans-serif"}}>Member since {getMemberSince()}</span>
            </div>
          </div>
          {subscription&&!subscription.has_access&&<Btn onClick={onUpgrade}>Upgrade to Premium</Btn>}
        </div>

        {/* Stats */}
        <div style={{maxWidth:'900px',margin:'28px auto 0',display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'14px',position:'relative'}}>
          {[
            {label:'Liked Videos',value:stats.totalLikes,color:'#ff6b6b',icon:'❤️'},
            {label:'Following',value:stats.totalSubscriptions,color:C.gold2,icon:'🔔'},
            {label:'Hyped Videos',value:stats.totalHypes,color:'#ff8c42',icon:'🔥'},
            {label:'Friends Invited',value:referralCount,color:C.green,icon:'📱'},
          ].map((s,i)=>(
            <div key={i} style={{background:'rgba(0,0,0,0.3)',borderRadius:'10px',padding:'16px',textAlign:'center',border:`1px solid ${C.border}`,backdropFilter:'blur(10px)'}}>
              <div style={{fontSize:'1.4em',marginBottom:'6px'}}>{s.icon}</div>
              <div style={{fontFamily:"'Cinzel',serif",fontSize:'1.8em',fontWeight:'900',color:s.color,textShadow:`0 0 16px ${s.color}44`}}>{s.value}</div>
              <div style={{color:C.muted,fontSize:'11px',letterSpacing:'1px',fontFamily:"'Barlow Condensed',sans-serif",marginTop:'4px'}}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',borderBottom:`1px solid ${C.border}`,overflowX:'auto',background:'rgba(4,0,0,0.8)',backdropFilter:'blur(10px)',position:'sticky',top:'66px',zIndex:99}}>
        {tabs.map(tab=>(
          <button key={tab.id} onClick={()=>setActiveTab(tab.id)} style={{padding:'15px 22px',background:'transparent',color:activeTab===tab.id?C.gold:C.muted,border:'none',borderBottom:activeTab===tab.id?`3px solid ${C.gold}`:'3px solid transparent',cursor:'pointer',fontSize:'13px',fontWeight:'800',whiteSpace:'nowrap',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1.5px',transition:'all 0.2s',textTransform:'uppercase'}}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{maxWidth:'900px',margin:'0 auto',padding:'40px 4%'}}>
        {loading?<div style={{textAlign:'center',padding:'80px',color:C.muted,fontFamily:"'Cinzel',serif"}}>Loading profile...</div>

        : activeTab==='overview'?(
          <div style={{display:'flex',flexDirection:'column',gap:'20px'}}>
            {/* Watch stats */}
            <div style={{background:`linear-gradient(135deg,#1a0303,#0e0101)`,borderRadius:'12px',padding:'28px',border:`1px solid ${C.border}`,position:'relative',overflow:'hidden'}}>
              <div style={{position:'absolute',top:0,left:0,right:0,height:'2px',background:`linear-gradient(90deg,transparent,${C.gold2},transparent)`}} />
              <h3 style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'1em',fontWeight:'800',letterSpacing:'3px',color:C.gold2,marginBottom:'20px'}}>📊 WATCH STATS</h3>
              <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'14px'}}>
                {[{v:watchStats.totalVideos,l:'Videos Started',c:C.gold},{v:watchStats.totalMinutes,l:'Minutes Watched',c:C.green},{v:watchStats.topSpeaker||'—',l:'Top Speaker',c:'#ff8c42'}].map(({v,l,c})=>(
                  <div key={l} style={{background:'rgba(0,0,0,0.3)',borderRadius:'8px',padding:'16px',textAlign:'center',border:`1px solid ${C.border}`}}>
                    <div style={{fontFamily:"'Cinzel',serif",fontSize:typeof v==='string'?'1em':'1.8em',fontWeight:'900',color:c,marginBottom:'6px'}}>{v}</div>
                    <div style={{color:C.muted,fontSize:'11px',letterSpacing:'1px',fontFamily:"'Barlow Condensed',sans-serif"}}>{l}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Subscription */}
            <div style={{background:`linear-gradient(135deg,#1a0303,#0e0101)`,borderRadius:'12px',padding:'28px',border:`1px solid ${C.border}`,position:'relative',overflow:'hidden'}}>
              <div style={{position:'absolute',top:0,left:0,right:0,height:'2px',background:`linear-gradient(90deg,transparent,${C.gold2},transparent)`}} />
              <h3 style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'1em',fontWeight:'800',letterSpacing:'3px',color:C.gold2,marginBottom:'20px'}}>📋 SUBSCRIPTION</h3>
              {[['Current Plan',plan.label,plan.color],['Status',subscription?.has_access?'✅ Active':'❌ Inactive',subscription?.has_access?C.green:'#ff6060'],...(subscription?.trial_days_left>0?[['Trial Ends In',`${subscription.trial_days_left} days`,C.gold]]:[])]
                .map(([label,val,color])=>(
                  <div key={label} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 0',borderBottom:`1px solid ${C.border}`}}>
                    <span style={{color:C.muted,fontSize:'13px'}}>{label}</span>
                    <span style={{color:color,fontWeight:'700',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>{val}</span>
                  </div>
                ))}
              {!subscription?.has_access&&<div style={{marginTop:'20px'}}><Btn onClick={onUpgrade} style={{width:'100%',padding:'14px'}}>⬆ Upgrade Now — Starting ₹99/month</Btn></div>}
            </div>

            {/* Invite teaser */}
            <div style={{background:`linear-gradient(135deg,#001a0a,#0a1a0a)`,borderRadius:'12px',padding:'28px',border:`1px solid ${C.green}44`}}>
              <h3 style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'1em',fontWeight:'800',letterSpacing:'2px',color:C.green,marginBottom:'8px'}}>📱 INVITE FRIENDS & EARN BONUS DAYS!</h3>
              <p style={{color:C.cream2,fontSize:'13px',marginBottom:'16px',lineHeight:1.6}}>Share your referral link. When a friend signs up, you both get 3 bonus trial days!</p>
              <div style={{display:'flex',gap:'12px',alignItems:'center',flexWrap:'wrap'}}>
                <Btn onClick={()=>setActiveTab('invite')} style={{background:`linear-gradient(135deg,#008040,#00d480)`}}>📱 Get My Invite Link</Btn>
                <span style={{color:C.muted,fontSize:'13px'}}>{referralCount} friends invited</span>
              </div>
            </div>

            {/* Recently liked */}
            {likedVideos.length>0&&(
              <div style={{background:`linear-gradient(135deg,#1a0303,#0e0101)`,borderRadius:'12px',padding:'28px',border:`1px solid ${C.border}`}}>
                <div style={{position:'absolute',top:0,left:0,right:0,height:'2px',background:`linear-gradient(90deg,transparent,${C.gold2},transparent)`}} />
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
                  <h3 style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'1em',fontWeight:'800',letterSpacing:'2px',color:C.gold2}}>❤️ RECENTLY LIKED</h3>
                  <button onClick={()=>setActiveTab('liked')} style={{background:'none',border:'none',color:C.gold2,cursor:'pointer',fontSize:'12px',fontFamily:"'Barlow Condensed',sans-serif",fontWeight:'700',letterSpacing:'1px'}}>VIEW ALL →</button>
                </div>
                {likedVideos.slice(0,3).map(v=>(
                  <div key={v.id} onClick={()=>onVideoSelect&&onVideoSelect(v)} style={{display:'flex',gap:'14px',alignItems:'center',cursor:'pointer',padding:'10px',borderRadius:'8px',transition:'all 0.2s',marginBottom:'8px',border:`1px solid transparent`}}
                    onMouseEnter={e=>{e.currentTarget.style.background='rgba(212,168,67,0.05)';e.currentTarget.style.borderColor=C.border;}}
                    onMouseLeave={e=>{e.currentTarget.style.background='transparent';e.currentTarget.style.borderColor='transparent';}}>
                    {v.thumbnail_url?<img src={v.thumbnail_url} alt={v.title} style={{width:'64px',height:'42px',objectFit:'cover',borderRadius:'6px',border:`1px solid ${C.border}`}}/>:<div style={{width:'64px',height:'42px',background:'rgba(212,168,67,0.06)',borderRadius:'6px',display:'flex',alignItems:'center',justifyContent:'center',border:`1px solid ${C.border}`}}>🎬</div>}
                    <div>
                      <div style={{color:C.cream,fontSize:'13px',fontWeight:'600',marginBottom:'3px'}}>{v.title}</div>
                      <div style={{color:C.muted,fontSize:'11px'}}>🎤 {v.speaker_name}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

        ) : activeTab==='invite'?(
          <div style={{display:'flex',flexDirection:'column',gap:'20px'}}>
            {/* Invite hero */}
            <div style={{background:`linear-gradient(135deg,#001a0a,#0a1a0a)`,borderRadius:'14px',padding:'36px',border:`1px solid ${C.green}44`,textAlign:'center'}}>
              <div style={{fontSize:'3em',marginBottom:'14px'}}>🎁</div>
              <h2 style={{fontFamily:"'Cinzel',serif",fontSize:'1.6em',fontWeight:'900',color:C.green,marginBottom:'10px',letterSpacing:'2px'}}>Invite Friends, Earn Bonus Days!</h2>
              <p style={{color:C.cream2,fontSize:'14px',maxWidth:'400px',margin:'0 auto 20px',lineHeight:1.7}}>Share your unique link. When a friend signs up:</p>
              <div style={{display:'flex',justifyContent:'center',gap:'20px',flexWrap:'wrap'}}>
                {[{v:'+3 days',l:'You get'},{v:'10 days',l:'Friend gets'}].map(({v,l})=>(
                  <div key={l} style={{background:'rgba(0,212,128,0.08)',borderRadius:'10px',padding:'14px 24px',border:`1px solid ${C.green}44`}}>
                    <div style={{fontFamily:"'Cinzel',serif",fontSize:'1.6em',fontWeight:'900',color:C.green}}>{v}</div>
                    <div style={{color:C.muted,fontSize:'12px',marginTop:'4px'}}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* Link */}
            <div style={{background:`linear-gradient(135deg,#1a0303,#0e0101)`,borderRadius:'12px',padding:'28px',border:`1px solid ${C.border}`}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'800',letterSpacing:'3px',color:C.gold3,marginBottom:'12px'}}>YOUR REFERRAL LINK</div>
              <div style={{display:'flex',gap:'10px'}}>
                <div style={{flex:1,background:'rgba(0,0,0,0.4)',border:`1px solid ${C.border}`,borderRadius:'8px',padding:'12px 16px',color:C.gold2,fontSize:'13px',fontFamily:'monospace',wordBreak:'break-all'}}>
                  {referralCode?`nethajiprime.com?ref=${referralCode}`:'Loading...'}
                </div>
                <Btn onClick={handleCopyLink} style={{flexShrink:0,background:copied?`linear-gradient(135deg,#008040,#00d480)`:`linear-gradient(135deg,${C.red2},${C.red})`}}>{copied?'✅ Copied!':'📋 Copy'}</Btn>
              </div>
              <p style={{color:C.muted,fontSize:'11px',marginTop:'8px'}}>Code: <strong style={{color:C.cream}}>{referralCode}</strong></p>
            </div>
            {/* Share */}
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:'14px'}}>
              <button onClick={handleWhatsApp} style={{padding:'16px',background:'#25D366',border:'none',borderRadius:'10px',cursor:'pointer',fontSize:'15px',fontWeight:'800',color:'#fff',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>📱 Share on WhatsApp</button>
              <button onClick={handleCopyLink} style={{padding:'16px',background:`linear-gradient(135deg,${C.red2},${C.red})`,border:'none',borderRadius:'10px',cursor:'pointer',fontSize:'15px',fontWeight:'800',color:'#fff',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>🔗 Share Link</button>
            </div>
            {/* Stats */}
            <div style={{background:`linear-gradient(135deg,#1a0303,#0e0101)`,borderRadius:'12px',padding:'28px',border:`1px solid ${C.border}`,textAlign:'center'}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'800',letterSpacing:'3px',color:C.gold3,marginBottom:'20px'}}>YOUR REFERRAL STATS</div>
              <div style={{display:'flex',justifyContent:'center',gap:'50px'}}>
                {[{v:referralCount,l:'Friends Invited',c:C.green},{v:referralCount*3,l:'Bonus Days Earned',c:C.gold}].map(({v,l,c})=>(
                  <div key={l}><div style={{fontFamily:"'Cinzel',serif",fontSize:'2.5em',fontWeight:'900',color:c,textShadow:`0 0 20px ${c}44`}}>{v}</div><div style={{color:C.muted,fontSize:'12px',letterSpacing:'1px',fontFamily:"'Barlow Condensed',sans-serif",marginTop:'4px'}}>{l}</div></div>
                ))}
              </div>
            </div>
          </div>

        ) : activeTab==='liked'?(
          likedVideos.length===0
            ?<div style={{textAlign:'center',padding:'80px',color:C.muted}}><div style={{fontSize:'3em',marginBottom:'16px'}}>❤️</div><p>No liked videos yet.</p></div>
            :<VideoGrid videos={likedVideos}/>

        ) : activeTab==='subscriptions'?(
          subscriptions.length===0
            ?<div style={{textAlign:'center',padding:'80px',color:C.muted}}><div style={{fontSize:'3em',marginBottom:'16px'}}>🔔</div><p>Not following anyone yet.</p></div>
            :<div>
              <div style={{display:'flex',gap:'10px',flexWrap:'wrap',marginBottom:'30px'}}>
                {subscriptions.map(s=>(
                  <div key={s.speaker_id} style={{background:'rgba(212,168,67,0.06)',border:`1px solid ${C.border}`,borderRadius:'20px',padding:'8px 18px',display:'flex',alignItems:'center',gap:'8px'}}>
                    <span>🎤</span><span style={{color:C.cream,fontWeight:'600',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>{s.speaker_id}</span>
                  </div>
                ))}
              </div>
              <VideoGrid videos={allVideos.filter(v=>subscriptions.map(s=>s.speaker_id).includes(v.speaker_name))}/>
            </div>

        ) : activeTab==='badges'?<Badges user={user}/>:null}
      </div>
    </div>
  );
}
export default UserProfile;